import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addTehsil = createAsyncThunk('addTehsil', async (data) => {

    let tehsil = data?.values?.tehsil?.map(val => ({
        "tehsil_name": val?.name
    }))

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'tehsil',
            data: {
                "district_id": data?.values?.district,
                // "status": data?.values?.status,
                "tehsil": tehsil
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})